import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import UserTrainingViewPage from "./UserTrainingView";

export const UserTrainingViewModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <UserTrainingViewPage />
        </ProtectedRoute> 
        {/* <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditSetBacksPage />
        </ProtectedRoute>  */}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default UserTrainingViewModule;